import {Search} from '@mui/icons-material';
import WithEtsyAccount from '../../../pages/etsy/WithEtsyAccount';
import {FeatureObject} from '../../../types/FeatureObject';
import {FeatureStatus} from '../../../types/FeatureStatus';
import {HelpTutorialEnum} from '../../../variables/helpTutorial';
import EtsyUpdateListingSeo from './EtsyUpdateListingSeo';

export const etsyUpdateListingSeo: FeatureObject = {
  type: 'feature',
  title: 'SEO optimisation',
  description: 'Update title and tags with ease',
  IconComponent: Search,
  showFeatureFrontPage: true,
  path: '/etsyUpdateListingSeo',
  component: (user) => (
    <WithEtsyAccount
      featureName="SEO optimisation"
      helpTutorialEnum={HelpTutorialEnum.ETSY_SEO_OPTIMIZATION}
      component={(selectedAccount) =>
        selectedAccount ? <EtsyUpdateListingSeo selectedAccount={selectedAccount} user={user} /> : null
      }
    />
  ),
  status: FeatureStatus.PROD,
  tags: ['etsy', 'seo', 'update', 'listing'],
};
